<template>
    <a class="rgpd-link" :href="url" target="_blank">{{ $t("general.RGPDLinkText") }}</a>
</template>
<script lang="ts">
import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

export default {
    setup() {
        const { t, locale } = useI18n({ useScope: "global" });
        const url = ref(t("general.rgpdUrl"));

        watch(locale, () => {
            url.value = t("general.rgpdUrl");
        });

        return {
            url
        };
    }
};
</script>
<style scoped>
.rgpd-link {
    text-decoration: underline;
    color: var(--screenTextColor);
    font-size: 0.85em;
    margin-bottom: 5px;
}
</style>
